function convertUTCDateToLocalDate(date: any) {
  const newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

  const offset = date.getTimezoneOffset() / 60;
  const hours = date.getHours();

  newDate.setHours(hours - offset);

  return newDate;
}


const formatDate = (dateString: string) => {
  const date = convertUTCDateToLocalDate(new Date(dateString));
  const year = date.getFullYear();
  // Add 1 because JavaScript months start at 0
  let month = (1 + date.getMonth()).toString();
  month = month.length > 1 ? month : '0' + month;
  let day = date.getDate().toString();
  day = day.length > 1 ? day : '0' + day;
  return month + '/' + day + '/' + year;
};

export default formatDate;



// WEBPACK FOOTER //
// ./src/components/utils/formatDate.ts